__turbopack_context__.v({
  "className": "NXcPaG_className",
  "variable": "NXcPaG_variable",
});
